/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMediaFromJSON, ApiMediaToJSON, } from './ApiMedia';
import { ApiPageFromJSON, ApiPageToJSON, } from './ApiPage';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiDomainFromJSON(json) {
    return ApiDomainFromJSONTyped(json, false);
}
export function ApiDomainFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'crossDomainEnabled': !exists(json, 'crossDomainEnabled') ? undefined : json['crossDomainEnabled'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'domainNameId': !exists(json, 'domainNameId') ? undefined : json['domainNameId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isPrimary': !exists(json, 'isPrimary') ? undefined : json['isPrimary'],
        'locationSuggestedProjectId': !exists(json, 'locationSuggestedProjectId') ? undefined : json['locationSuggestedProjectId'],
        'pages': !exists(json, 'pages') ? undefined : (json['pages'].map(ApiPageFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'screenshot': !exists(json, 'screenshot') ? undefined : ApiMediaFromJSON(json['screenshot']),
        'screenshotId': !exists(json, 'screenshotId') ? undefined : json['screenshotId'],
        'secure': !exists(json, 'secure') ? undefined : json['secure'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function ApiDomainToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'crossDomainEnabled': value.crossDomainEnabled,
        'domain': value.domain,
        'domainNameId': value.domainNameId,
        'id': value.id,
        'isPrimary': value.isPrimary,
        'locationSuggestedProjectId': value.locationSuggestedProjectId,
        'pages': value.pages === undefined ? undefined : (value.pages.map(ApiPageToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'screenshot': ApiMediaToJSON(value.screenshot),
        'screenshotId': value.screenshotId,
        'secure': value.secure,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'url': value.url,
    };
}
